import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: {
        info: {
            "orgId": "d52e96db-23de-4ff9-b9ec-82e65e9515fa",
            "orgName": "Acme Corporation"
        },
        countryDomain: {
            "countryIndex": 216
        },
        timeConfig: {
            "timezone": "America/Los_Angeles",
            "ntpServer1": "time.google.com",
            "ntpServer2": "",
            "ntpServer3": ""
        },
        inventoryDeviceAccount: {
            "userName": "org_inventory_admin",
            "password": "OrgSecurePass2025!"
        }
    }
};

export const orgGeneralSlice = createSlice({
    name: "orgGeneral",
    initialState,
    reducers: {
        updateOrgGeneral: (state, action) => {
            state.data = action.payload.data;
        },
    },
});

export const { updateOrgGeneral } = orgGeneralSlice.actions;

export default orgGeneralSlice.reducer;